import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import ViewWrapper from "./ViewWrapper";
import "../../styles/Views/education.scss";

const educationData = [
  {
    school: "Tel Aviv University",
    degree: "B.Sc. Computer Science & Psychology (double major)",
    year: "2021 – 2026",
    gpa: "89 / 92",
    detail:
      "Demanding double-major program combining rigorous CS theory with cognitive science. Strong GPA across both disciplines. Active teaching assistant and researcher.",
    tags: ["Algorithms", "OS", "Networks", "Cognitive Science", "Statistics"],
  },
  {
    school: "Technion — Israel Institute of Technology",
    degree: "Cybersecurity — Offensive & Defensive Program",
    year: "2024 – 2025",
    gpa: "93",
    detail:
      "Highly technical certification program",
    tags: ["Network Security", "OSINT"],
  },
  {
    school: "Appleseeds Academy",
    degree: "Full-Stack Developer Bootcamp",
    year: "Jan – Jun 2021",
    gpa: null,
    detail:
      "Intensive hands-on bootcamp covering full-stack web development with JavaScript, React, Node.js, and database integration — the foundation for subsequent professional development.",
    tags: ["React", "Node.js", "JavaScript", "REST APIs"],
  },
];

const Education = () => {
  const [selected, setSelected] = useState(null);

  return (
    <ViewWrapper>
      <div className="edu-page">
        <motion.div
          className="edu-header"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <span className="edu-eyebrow">Education</span>
          <h1 className="edu-heading">Academic Background</h1>
          <p className="edu-sub">
            Strong theoretical foundations across computer science, cybersecurity,
            and psychology — built at two of the region's top institutions.
          </p>
        </motion.div>

        <div className="edu-list">
          {educationData.map((edu, i) => (
            <motion.div
              key={edu.school}
              className={`edu-card ${selected?.school === edu.school ? "edu-card--active" : ""}`}
              initial={{ opacity: 0, x: -40 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: 0.15 * i + 0.2 }}
              onClick={() => setSelected(selected?.school === edu.school ? null : edu)}
            >
              <div className="edu-card-main">
                <div className="edu-card-left">
                  <span className="edu-year">{edu.year}</span>
                  <h3 className="edu-school">{edu.school}</h3>
                  <p className="edu-degree">{edu.degree}</p>
                  <div className="edu-tags">
                    {edu.tags.map((t) => (
                      <span className="edu-tag" key={t}>{t}</span>
                    ))}
                  </div>
                </div>
                <div className="edu-card-right">
                  {edu.gpa && (
                    <div className="edu-gpa-badge">
                      <span className="edu-gpa-label">GPA</span>
                      <span className="edu-gpa-value">{edu.gpa}</span>
                    </div>
                  )}
                  <button className="edu-expand-btn" aria-label="expand">
                    {selected?.school === edu.school ? "−" : "+"}
                  </button>
                </div>
              </div>

              <AnimatePresence>
                {selected?.school === edu.school && (
                  <motion.div
                    className="edu-detail"
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: "auto" }}
                    exit={{ opacity: 0, height: 0 }}
                    transition={{ duration: 0.35 }}
                  >
                    <p>{edu.detail}</p>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>
      </div>
    </ViewWrapper>
  );
};

export default Education;
